import React, { useContext, useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import { FormHelperText, InputLabel } from '@material-ui/core';
import { SecondaryButton, TextBox } from '../../../Core/FormInput';
import AppContext from '../../../App/AppContext';
import { addInspectionSheetList, updateInspectionSheetList } from '../../../Core/Service/inspectionSheetList-service';

const AddEditInspectionSheetList = (props) => {
    const { showToast } = useContext(AppContext);

    const [state, setState] = useState({
        errors: {},
        listName: '',
        listId: null,
        btnLoader: false
    });

    useEffect(() => {
        if (props.listData) {
            setState((st) => ({
                ...st,
                listName: props.listData.listName || '',
                listId: props.listData.listId || props.listData.id || null
            }));
        }
    }, [props.listData]);

    const inputChange = (e) => {
        const { name, value } = e.target;
        setState((st) => ({ ...st, [name]: value, errors: { ...st.errors, [name]: '' } }));
    };

    const validations = () => {
        const { listName } = state;
        let formIsValid = true;
        let errors = {};
        if (!listName || !listName.trim()) {
            errors.listName = 'List Name is required';
            formIsValid = false;
        }
        setState((st) => ({ ...st, errors: errors }));
        return formIsValid;
    };

    const handleSubmit = async () => {
        if (validations()) {
            setState((st) => ({ ...st, btnLoader: true }));
            let res;
            if (state.listId) {
                res = await updateInspectionSheetList(state.listId, state.listName);
            } else {
                res = await addInspectionSheetList(state.listName);
            }
            setState((st) => ({ ...st, btnLoader: false }));
            if (res && res.success) {
                showToast(res.message || (state.listId ? 'Updated successfully' : 'Added successfully'));
                props.onFormSubmit(true);
            } else {
                showToast((res && res.message) || 'Operation failed');
            }
        }
    };

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} className="mandatory-fields">
                <InputLabel shrink required>
                    List Name
                </InputLabel>
                <TextBox
                    placeholder="List Name"
                    value={state.listName}
                    onChange={inputChange}
                    name="listName"
                    autoFocus
                />
                <FormHelperText error>{state.errors.listName}</FormHelperText>
            </Grid>
            <Grid item xs={12}>
                <SecondaryButton onClick={handleSubmit} fullWidth className="submit_btn" isBtnLoader={state.btnLoader}>
                    Submit
                </SecondaryButton>
            </Grid>
        </Grid>
    );
};

export default AddEditInspectionSheetList;
